"use strict";

/*
 * Better trim - you can supply a string or regex
 */

function escapeRegex(string) {
  return string.replace(/[\[\](){}?*+\^$\\.|\-]/g, "\\$&");
}

String.prototype.trim = function trim(characters, flags) {
  characters = characters || "[s﻿ ]";
  flags = flags || "g";
  if (typeof characters !== "string" || typeof flags !== "string") {
    throw new TypeError("argument must be string");
  }

  if (!/^[gi]*$/.test(flags)) {
    throw new TypeError("Invalid flags supplied '" + flags.match(new RegExp("[^gi]*")) + "'");
  }

  characters = escapeRegex(characters);

  return this.replace(new RegExp("^(" + characters + ")+|(" + characters + ")+$", flags), '');
};


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/plugins/string.trim.js
 **/